import {useQuery, useMutation, useQueryClient} from "@tanstack/react-query";
import membershipService from "../services/membership-type.service";

export function useMembershipTypes(params) {
  return useQuery({
    queryKey: ["membership-types", params],
    queryFn: () => membershipService.list(params),
  });
}

export function useCreateMembershipType() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: membershipService.create,
    onSuccess: () => qc.invalidateQueries({queryKey: ["membership-types"]}),
  });
}

export function useUpdateMembershipType() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({id, payload}) => membershipService.update(id, payload),
    onSuccess: () => qc.invalidateQueries({queryKey: ["membership-types"]}),
  });
}

export function useDeleteMembershipType() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: membershipService.remove,
    onSuccess: () => qc.invalidateQueries({queryKey: ["membership-types"]}),
  });
}

export function useAssignMembershipToEnrollment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: membershipService.assignToEnrollment,
    onSuccess: () => {
      qc.invalidateQueries({queryKey: ["enrollments"]});
      qc.invalidateQueries({queryKey: ["enrollment-by-id"]});
    },
  });
}
